<template>
  <div class="shop_content"
       v-if="JSON.stringify(shop) != '{}'">
    <top-ad></top-ad>
    <top-nav></top-nav>
    <!-- 店铺图片 -->
    <div class="middle_center">
      <router-link :to="{path: 'shopIndex', query: {shopId: shopId}}">
        <img class="logo"
             :src="shop && shop.shopLogo ? common.showPic(shop.shopLogo) : require('@/assets/images/Headportrt.png')"
             :onerror="common.defaultAvatar()">
      </router-link>
      <!-- 店铺情况 -->
      <div class="info">
        <Row type="flex"
             :gutter="6"
             justify="start"
             align="bottom">
          <Col style="font-weight: bold; font-size: 18px;">{{shop ? shop.shopName : '--'}}</Col>
          <Col>
          <Rate disabled
                icon="md-star"
                v-model="grade" />
          </Col>
        </Row>
        <!--        二级域名-->
        <a v-if="shop.domain"
           class="shop_domain"
           target="_blank"
           :href="shop.domain">{{shop.domain}}</a>
        <Row class="target"
             type="flex"
             justify="space-between">
          <Col>
          <p>商品数</p>
          <p class="primary">
            <span>{{shop ? shop.productTotalNum : 0}}</span>款
          </p>
          </Col>
          <Col>
          <p>上新数</p>
          <p class="primary">
            <span>{{shop ? shop.newQuantity : 0}}</span>款
          </p>
          </Col>
          <Col>
          <p>访客数</p>
          <p class="primary">
            <span>{{shop ? shop.totalvisitnum : 0}}</span>
          </p>
          </Col>
          <Col>
          <p>总人气</p>
          <p class="primary">
            <span>{{shop ? shop.totalBrowseNum : 0}}</span>
          </p>
          </Col>
        </Row>
      </div>
      <!-- 搜索部分 -->
      <div class="search">
        <Row>
          <Col>
          <div class='search_info'>
            <input v-model.trim="searchName" style="width: 600px"
                   placeholder='搜索关键字' />
            <router-link :to="{path: 'goods', query: {shopId: shopId, key: searchName.replace(/\s*/g,'')}}"
                         class="search_logo">搜本店
            </router-link>
            <router-link :to="{path: '/searchGoods', query: {key: searchName.replace(/\s*/g,'')}}"
                         class="back_black">全站搜索
            </router-link>
          </div>
          </Col>
          <Col>
          <Row class="operate" style="width: 600px;margin-left: 150px"
               type="flex"
               justify="end"
               align="middle">
            <Col v-if="shop && shop.qq"
                 style="display: flex;align-items: center;cursor: pointer;">
            <img style="width: 20px;"
                 src="@/assets/images/bindingQQ.png">
            <span @click="linkService">联系客服</span>
            </Col>
            <!-- <Col>
              <img src="@/assets/images/distributionone.png">
              <span v-if="distributorStatus === 1">你是分销商</span>
              <span v-else-if="distributorStatus === 0">分销申请审核中</span>
              <span v-else
                    style="cursor: pointer"
                    @click="goApply">申请分销商</span>
              </Col> -->
            <Col>
            <img v-if="shop? shop.isShopCollect: 0"
                 class="my_icon"
                 src="@/assets/images/collected.png">
            <img v-else
                 class="my_icon"
                 src="@/assets/images/Notcollected.png">
            <span style="cursor: pointer"
                  @click="collectThings">店铺收藏</span>
            </Col>
          </Row>
          </Col>
          <!--          通知/-->
          <Col class="notice"
               v-if="noticeList && noticeList.length> 0">
          <Row type="flex"
               justify="end"
               style="flex-wrap: wrap;width: 600px;margin-left: 200px">
            <Col style="margin-right: 5px;">
            <img src="@/assets/images/notice.png"
                 alt="">
            </Col>
            <Col>
            <span style="margin-right: 5px;">本店</span>
            </Col>
            <Col>
            <swiper :options="swiperAdOption"
                    class="notice_swiper">
              <swiper-slide v-for="(item, key) in noticeList"
                            :key="key"
                            data-id="key">
                <p class="ellipsis primary">
                  <span style="text-align: left;max-width: 200px;">货号为：{{item.productSn}} 的商品下架了;</span>
                  <span style="color:#020202">请注意更新 {{common.renderTime(item.createTime)}}</span>
                </p>
              </swiper-slide>
              <div class="swiper-pagination"
                   slot="pagination"></div>
            </swiper>
            </Col>
          </Row>
          </Col>
        </Row>
      </div>
    </div>
    <!-- 菜单 -->
    <div class="menu" >
      <Menu class="tabs"
            mode="horizontal"
            theme="light"
            :active-name="activeName"
            @on-select="(value) => selectMenu(value, shop.shopName)" style="background-color: #ef6c00;color: #ffffff;">
        <MenuItem name="shopIndex" style="color: #fbf7f7;"> 店铺首页
        </MenuItem>
        <MenuItem name="newReleases" style="color: #fbf7f7;"> 最新上架
        </MenuItem>
        <MenuItem name="goods" style="color: #fbf7f7;"> 全部商品
        </MenuItem>
        <MenuItem name="clearInventory" style="color: #fbf7f7;"> 清仓专区
        </MenuItem>
        <MenuItem name="offGoods" style="color: #fbf7f7;"> 下架商品
        </MenuItem>
        <!-- <MenuItem name="salesPromotion">
        活动专区
        </MenuItem> -->
        <MenuItem name="download" style="color: #fbf7f7;"> 数据包下载
        </MenuItem>
        <MenuItem name="about" style="color: #fbf7f7;"> 关于店铺
        </MenuItem>
        <!-- <MenuItem name="6">
        企业资质
        </MenuItem> -->
      </Menu>
    </div>
    <router-view />
    <div v-if="shop">
      <apply-distributor :modal="modal"
                         :shopName="shop.shopName"
                         :storeList="storeList"></apply-distributor>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import TopAd from '@/layout/components/Header/TopAd'
import TopNav from '@/layout/components/Header/TopNav'
import Footer from '@/layout/components/Footer/index'
import {
  getShopInfo, getNoticeInfo
} from '@/api/shop'
import {
  onlineStoreList,
  isDistributor
} from '@/api/user'
import ApplyDistributor from '@/components/ApplyDistributor'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'shop',
  components: {
    TopAd,
    TopNav,
    Footer,
    ApplyDistributor,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      applyVisible: false,
      shopId: null,
      shop: {},
      grade: 5,
      activeName: 'shopIndex',
      searchName: '',
      modal: {
        applyVisible: false
      },
      storeList: [],
      distributorStatus: null,
      swiperAdOption: {
        direction: 'vertical',
        loop: true,
        autoplay: {
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          delay: 3000 // 自动切换的时间间隔（单位ms）
        }
      },
      noticeList: []
    }
  },
  created() {
    this.shopId = this.$route.query.shopId
    if (this.shopId) {
      this.init()
    } else {
      this.$router.back()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.activeName = this.$route.name
    })
    let token = window.localStorage.getItem('token')
    if (token) {
      this.isDistributor()
    }
  },
  methods: {
    isDistributor() {
      isDistributor({
        memberId: this.userid,
        mchtId: this.shopId
      }).then(res => {
        this.distributorStatus = res.data.status
      })
    },
    init() {
      getShopInfo({
        mchtId: this.shopId
      }).then(res => {
        this.shop = res.data
        if (this.shop.shopName) {
          document.title = this.shop.shopName + '_厂家批发价格_一手货源_品牌_怎么样-鞋库网'
          if (document.querySelector('meta[name="keywords"]')) {
            document.querySelector('meta[name="keywords"]').setAttribute('content', this.shop.shopName + ',厂家批发价格, 旗舰店,网上购物商城,一手货源,品牌,怎么样, 鞋库网')
          }
          if (document.querySelector('meta[name="description"]')) {
            document.querySelector('meta[name="description"]').setAttribute('content', this.shop.shopName + ',厂家批发价格,旗舰店专卖店,专业批发拿货平台,鞋子一手货源批发童鞋,运动鞋,高跟鞋,皮鞋男鞋女鞋,价格,报价,参数,图片,品牌等。')
          }
        }
        this.grade = this.shop.grade || 5
      })
      getNoticeInfo({ mchtId: this.shopId }).then(res => {
        this.noticeList = res.data
      })
    },
    selectMenu(value) {
      this.$router.push({
        path: value,
        query: {
          shopId: this.shopId
        }
      })
      if (this.shop.shopName) {
        document.title = this.shop.shopName + '_厂家批发价格_一手货源_品牌_怎么样-鞋库网'
        if (document.querySelector('meta[name="keywords"]')) {
          document.querySelector('meta[name="keywords"]').setAttribute('content', this.shop.shopName + ',厂家批发价格, 旗舰店,网上购物商城,一手货源,品牌,怎么样, 鞋库网')
        }
        if (document.querySelector('meta[name="description"]')) {
          document.querySelector('meta[name="description"]').setAttribute('content', this.shop.shopName + ',厂家批发价格,旗舰店专卖店,专业批发拿货平台,鞋子一手货源批发童鞋,运动鞋,高跟鞋,皮鞋男鞋女鞋,价格,报价,参数,图片,品牌等。')
        }

      }
    },
    // 收藏
    collectThings() {
      let params = {
        type: 1,
        id: this.shopId,
        memberId: this.userid
      }
      this.$store.dispatch('CollectThings', params).then((res) => {
        window.console.log('收藏', res)
        this.init()
      }).catch(() => {
      })
    },
    onlineStoreList() {
      onlineStoreList({
        memeberId: this.userid,
        status: 1,
        sort: ''
      }).then(res => {
        this.storeList = res.data
      })
    },
    goApply() {
      let token = window.localStorage.getItem('token')
      if (!token) {
        this.$router.push({
          path: '/login'
        })
        return
      }
      this.onlineStoreList()
      this.modal.applyVisible = true
    },
    linkService() {
      let token = window.localStorage.getItem('token')
      if (!token) {
        this.$router.push({
          path: '/login'
        })
        return
      }
      window.open('https://wpa.qq.com/msgrd?v=3&uin=' + this.shop.qq + '&site=qq&menu=yes')
    },
  },
  computed: {
    ...mapState(['userid', 'username'])
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.activeName = this.$route.name
      },
      // 深度观察监听
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/my-theme/index.less";

.shop_content {
  color: #020202;
}

.middle_center {
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 auto;
  width: 1200px;

  .search {
    flex: 1;
    width: 600px;
    text-align: right;
    margin: 0 auto;
  }

  .notice {
    height: 28px;
    color: #999999;
    margin-right: 15px;
    margin-top: 10px;
    overflow: hidden;

    img {
      width: 15px;
    }

    .notice_swiper {
      width: 100%;
      height: 28px;
      margin-right: 5px;
    }
  }

  .shop_domain {
    text-align: left;
    color: #0092cc;
    font-size: 14px;
    margin: 5px 0;
  }

  .target {
    text-align: center;
    margin-top: 10px;
    color: #333333;
    font-size: 12px;
    padding: 0 5px;
  }

  .logo {
    width: auto;
    max-width: 250px;
    height: 100px;
    margin-right: 30px;
    -o-object-fit: contain;
    object-fit: contain;
  }

  .operate {
    margin-top: 15px;

    > div {
      margin-right: 15px;

      img {
        width: 11px;
        /*margin-right: 5px;*/
        vertical-align: baseline;
      }
    }
  }
}

.search_info {
  margin-left: 50px;
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.search_logo {
  background: @primary-color;
  color: #ffffff;
  width: 56px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 4px 4px 0;
}

.back_black {
  padding: 0 5px;
  background: #333333;
  color: #ffffff;
  line-height: 32px;
  border-radius: 6px;
  margin-left: 10px;
}

.back_black:hover {
  color: #ffffff;
}

.search_info input {
  flex: 1;
  height: 32px;
  line-height: 32px;
  border: 1px solid @primary-color;
  padding: 0 10px;
  border-radius: 4px 0 0 4px;
}

.menu {
  li {
    font-size: 14px;
  }
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active{
  border-bottom: 2px solid #ef0016;
}

.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover{
  border-bottom: 2px solid #ef0016;
}

.tabs {
  width: 1200px;
  margin: 0 auto;
  color: #020202;
  font-weight: 400;
  background: whitesmoke;
}
</style>
